module.exports = __webpack_public_path__ + "img/image7.3f1747a3.png";